<script>
  import Layout from '../../layouts/layout.svelte'
  import EmptyState from '../../components/empty_state.svelte'
  import { Button } from '../../components/ui'
</script>

<Layout>
  <div class="flex items-center justify-center min-h-[60vh]">
    <EmptyState icon="search" title="Page not found" description="This page doesn't exist, or the record it pointed to was removed.">
      <Button variant="primary" href="/">Back to Campaigns</Button>
    </EmptyState>
  </div>
</Layout>
